<template>
    <validation-observer
        ref="observer"
        v-slot="{ invalid }"
    >
        <form @submit.prevent="submit">
             <validation-provider
                v-slot="{ errors }"
                name="Name"
                rules="required|max:50"
            > 
                <v-text-field
                v-model="seminar.name"
                :counter="50"
                :error-messages="errors"
                label="セミナー名"
                required
                ></v-text-field>
            </validation-provider>

            <validation-provider
                v-slot="{ errors }"
                name="description"
                rules="max:300"
            >
                <v-textarea
                v-model="seminar.description"
                :counter="300"
                :error-messages="errors"
                label="概要"
                ></v-textarea>
            </validation-provider>

            <validation-provider
                v-slot="{ errors }"
                name="capacity"
                rules="integer|min_value:0"
            >
                <v-text-field
                v-model="seminar.capacity"
                :error-messages="errors"
                :label="getCapacityLabel(seminar)"
                type="number" 
                onkeydown="return event.keyCode !== 69"
                min="0" 
                ></v-text-field>
            </validation-provider>
            



                <v-menu
                    v-model="menu_date"
                    :close-on-content-click="false"
                    :nudge-right="400"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="seminar.date"
                        label="開催日"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="seminar.date"
                        no-title
                        locale="jp-ja"
                        :day-format="date => new Date(date).getDate()"
                        @input="menu_date = false"
                    ></v-date-picker>
                </v-menu>



            <span>開催時間：</span>
            <validation-provider
                v-slot="{ errors }"
                name="start_time"
                rules="required_time"
            >
                <vue-timepicker 
                    minute-interval="10"
                    v-model="seminar.start_time"
                    placeholder="時間を入力"
                    hour-label="時"
                    minute-label="分"
                    manual-input
                    auto-scroll
                    hide-clear-button
                    :error-messages="errors"
                ></vue-timepicker>
                <span><font color="red"> {{ errors[0] }}</font></span>
            </validation-provider>
            
            <span>～</span>
            <validation-provider
                v-slot="{ errors }"
                name="end_time"
                rules="required_time"
            >
                <vue-timepicker 
                    minute-interval="10"
                    v-model="seminar.end_time"
                    placeholder="時間を入力"
                    hour-label="時"
                    minute-label="分"
                    manual-input
                    auto-scroll
                    hide-clear-button
                    :error-messages="errors"
                ></vue-timepicker>
                <span><font color="red"> {{ errors[0] }}</font></span>
            </validation-provider> 


             <validation-provider
                v-slot="{ errors }"
                name="acceptWatcher"
                rules="required"
            > 
                <v-switch
                v-model="seminar.acceptWatcher"
                :label="seminar.acceptWatcher?'視聴参加可':'視聴参加不可'"
                :error-messages="errors"
                ></v-switch>
                <span><font color="red"> {{ errors[0] }}</font></span>
            </validation-provider>



             <validation-provider
                v-slot="{ errors }"
                name="chatroom"
                rules=""
                v-if="$route.params.type == 'S'"
            > 
                <div class="mt-5">
                    <v-select
                        v-model="seminar.chatroom"
                        :items="roomItems"
                        item-text="room"
                        item-value="abbr"
                        label="応答用チャット"
                        return-object
                        single-line
                        :error-messages="errors"
                    ></v-select>
                </div>
                <span><font color="red"> {{ errors[0] }}</font></span>
            </validation-provider>


             <validation-provider
                v-slot="{ errors }"
                name="Link"
                :rules="{ url: /https?:\/\/[\w!\?/\+\-_~=;\.,\*&@#\$%\(\)'\[\]]+/ }"
            > 
                <v-text-field
                v-model="seminar.link"
                :error-messages="errors"
                label="チャットワークの告知文のリンク"
                ></v-text-field>
                <span><font color="red"> {{ errors[0] }}</font></span>
            </validation-provider>




            <!-- <validation-provider
                v-slot="{ errors }"
                rules="required"
                name="checkbox"
            >
                <v-checkbox
                v-model="checkbox"
                :error-messages="errors"
                value="1"
                label="Option"
                type="checkbox"
                required
                ></v-checkbox>
            </validation-provider> -->
            <div class="mt-4">
                <v-btn
                    class="mr-4"
                    type="submit"
                    :disabled="invalid"
                >
                    登録
                </v-btn>
                <v-btn 
                    class="mr-4"
                    @click="cancel">
                    キャンセル
                </v-btn>
                <v-btn 
                    class="mr-4"
                    @click="delete_event">
                    削除
                </v-btn>
            </div>
        </form>
    </validation-observer>
</template>

<script>
    import { required, digits, email, max, regex, integer, min_value } from "vee-validate/dist/rules";
    import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from "vee-validate";
    import VueTimepicker from "vue2-timepicker";
    import "vue2-timepicker/dist/VueTimepicker.css";
    import { mapActions } from "vuex";

    setInteractionMode("eager");

    extend("digits", {
        ...digits,
        message: "{_field_} needs to be {length} digits. ({_value_})",
    });

    extend("required", {
        ...required,
        message: "入力してください",
    });

    extend("required_time", {
        validate: value => {
            if(value.HH == "" || value.mm == ""){
                return false;
            }
            return true;
        },
        message: "時間を入力してください"
    });

    extend("max", {
        ...max,
        message: "{length}文字以下にしてください",
    });

    extend("min_value", {
        ...min_value,
        message: "0より大きい数字を入力してください",
    });

    extend("regex", {
        ...regex,
        message: "{_field_} {_value_} does not match {regex}",
    });

    extend("url", {
        ...regex,
        message: "正しいURLを入力してください",
    });

    extend("email", {
        ...email,
        message: "Email must be valid",
    });

    extend("integer", {
        ...integer,
        message: "半角の数字を入力してください",
    });

    export default {
        name: "createGroupConsulting",
        
        components: {
            ValidationProvider,
            ValidationObserver,
            VueTimepicker,
        },
        created(){
            //編集対象のIDがないときは、データの復元処理を行わない
            if(!this.$route.params.gc_id) return;

            //既存データを取得
            const refevent = this.$store.getters.getEventById(this.$route.params.gc_id);

            if(refevent){
                //コピーの場合は、IDを初期化            
                if(this.$route.params.copy) {
                    var cloned = Object.assign(refevent);
                    cloned.id = null;
                    this.seminar = cloned;
                }else{
                    this.seminar = refevent;
                }
            }else{
                this.$router.push({name : "host.groupConsulting"});
            }
        },
        data: () => ({
            seminar: {
                name: "",
                description: "",
                capacity : null, //null
                acceptWatcher : false,
                date: new Date().toISOString().substr(0, 10),
                start_time: {
                    HH: "12",
                    mm: "00"
                },
                end_time: {
                    HH: "13",
                    mm: "00"
                },
            },
            menu_date: false,
            items: [
                "Item 1",
                "Item 2",
                "Item 3",
                "Item 4",
            ],
            checkbox: null,
            invalid : true,
            snackbar_text: "追加しました",
            
            chatroom: { room: '応答用チャットなし', abbr: 'null' },
            // chatroom: null,
            roomItems: [
                { room: '応答用チャットなし', abbr: null },
                { room: '応答用チャット１', abbr: 'chat1' },
                { room: '応答用チャット２', abbr: 'chat2' },
                // { room: '応答用チャット３', abbr: 'chat3' },
            ],

        }),

        computed: {
            validateForm(){ 
                return this.invalid;
            },
            getReturnURL(){
                console.log(this.$route.params.type)
                console.log(this.seminar)
                if(this.$route.params.type == 'S') return "host.seminar"
                return "host.groupConsulting"
                // return "seminar.detail"
            },
            getEventLabel(){
                if(this.$route.params.type == 'S') return "セミナー名"
                return "グルコン名"
            },
        },

        methods: {
            ...mapActions(["showInforBar", "addEvent", "updateEvent", "clearEvent", "deleteEvent"]),
            
            submit () {
                //データのバリデーション
                this.$refs.observer.validate();

                if(!this.seminar.type){
                    this.seminar.type = this.$route.params.type;
                }
                if(!this.seminar.capacity) this.seminar.capacity = 0;

                if(this.$route.params.gc_id && this.seminar.id){
                    if(!this.seminar.watcher){
                        this.seminar.watcher = [];
                    }
                    //既存データの編集画面のときは更新
                    this.updateEvent({id: this.seminar.id, seminar: this.seminar});
                    console.log("update");
                }else{
                    this.seminar.attendee = [];
                    this.seminar.watcher = [];
                    //新規作成orコピーの新規作成
                    this.addEvent(this.seminar);
                    console.log("create new/copy");
                    
                }

                //一覧ページに遷移
                this.$router.push({name : this.getReturnURL});
                //登録・更新完了メッセージを表示
                this.showInforBar(this.snackbar_text);
                //eventの初期化
                this.seminar = {};
            },
            cancel () {
                this.seminar = {};
                this.$router.push({name : this.getReturnURL});
            },
            delete_event () {
                if(confirm("削除しますか？")){
                    this.deleteEvent({id:this.seminar.id});
                    this.$router.push({name : this.getReturnURL});
                }
            },
            clear () {
                this.name = "";
                this.description = "";
                this.date = new Date().toISOString().substr(0, 10),
                // menu_date = false;
                this.capacity = null;
                this.checkbox = null;
                this.$refs.observer.reset();
            },
            getCapacityLabel(seminar){
                if(seminar.capacity == 0 || !seminar.capacity){
                    return '定員なし（何人でも参加可能）'
                }
                return "定員：" + seminar.capacity + "（「定員なし」にしたい場合は数字を削除してください）"
            },
        }
        
    };
</script>
